import React from 'react';
import { motion } from 'framer-motion';
import { tools } from '../data/profile';
import type { Lang, LocaleContent } from '../types/profile';
interface StrengthsSectionProps {
  lang: Lang;
  content: LocaleContent;
}
export function StrengthsSection({
  lang,
  content
}: StrengthsSectionProps) {
  const isThai = lang === 'th';
  return <section id="strengths" aria-labelledby="strengths-heading" className="print-band scroll-mt-28 bg-paper py-16 sm:py-24 print:py-6" data-id="element-157" data-mp="2t3n73fpo1z5o">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-158" data-mp="21ch48rik9ncp">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-10" data-id="element-159" data-mp="21f3mbl32vl96">
          <div className="lg:col-span-4" data-id="element-160" data-mp="25e2q32d2pbz1">
            <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-sage-deep" data-id="element-161" data-mp="2adxemz9dlpgx">
              03 — {content.strengthsLabel}
            </p>
            <h2 id="strengths-heading" className={`mt-4 font-display font-light text-charcoal ${isThai ? 'text-[2rem] leading-[1.45] sm:text-[2.5rem]' : 'text-[2.25rem] leading-[1.05] tracking-[-0.02em] sm:text-[2.75rem]'}`} data-id="element-162" data-mp="3gt7tk8l13ejp">
              {content.strengthsHeading}
            </h2>
          </div>

          <motion.div data-reveal initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1]
        }} className="print-avoid lg:col-span-7 lg:col-start-6" data-id="element-163" data-mp="2au4ysa64o42d">
            <p className={`text-charcoal ${isThai ? 'text-[1.15rem] leading-[1.95] sm:text-[1.3rem]' : 'font-display text-[1.35rem] font-light leading-[1.5] sm:text-[1.65rem]'}`} data-id="element-164" data-mp="1s583q42wp7j3">
              {content.strengths}
            </p>

            <ul className="mt-10 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-line bg-line sm:grid-cols-2" data-id="element-165" data-mp="1e571ak6zts1i">
              {content.strengthTags.map((tag, i) => <li key={tag} className="group flex items-center gap-4 bg-paper px-5 py-4 transition-colors duration-300 hover:bg-ivory" data-id="element-166" data-mp="18j6lntotg9fx" data-mpi={i}>
                  <span className="font-mono text-[12px] text-sage-deep" data-id="element-167" data-mp="zigq8r3gwl2q">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="text-[16px] text-charcoal" data-id="element-168" data-mp="1n8um6sp6b42l">{tag}</span>
                  <span aria-hidden="true" className="decor ml-auto h-px w-4 bg-sage transition-all duration-300 group-hover:w-8 group-hover:bg-sage-deep" data-id="element-169" data-mp="1ra64se9mqp1a" />
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="print-avoid mt-16 flex flex-col gap-4 border-t border-line pt-8 sm:mt-20 md:flex-row md:items-baseline md:gap-10" data-id="element-170" data-mp="2665iq5jf7jec">
          <h3 className="shrink-0 text-[14px] text-ink-soft" data-id="element-171" data-mp="2azzywyzthg8o">{content.toolsHeading}</h3>
          <ul className="flex flex-wrap items-center gap-x-1 gap-y-2" data-id="element-172" data-mp="2kaw3s9cvbmvy">
            {tools.map((tool, i) => <li key={tool} className="flex items-center" data-id="element-173" data-mp="2g91233r0z7hn" data-mpi={i}>
                <span className="text-[16px] text-charcoal transition-colors hover:text-sage-deep" data-id="element-174" data-mp="2u1gyvmtc29a4">
                  {tool}
                </span>
                {i < tools.length - 1 && <span aria-hidden="true" className="mx-3 h-1 w-1 rounded-full bg-sage" data-id="element-175" data-mp="21ew7imcuxx6k" />}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}